import { handleExceptions, mapError } from "../../ApiClient/WebApiUtil.js";
import { Admittance_GET$002D$002Fadmittance$002FprincipalId$002Fprincipalprivileges$002F$002DAsync, Models_updateIpWhiteListDTO, Admittance_PUT$002D$002Fadmittance$002FprincipalId$002Fipwhitelist$002F$002DAsync, Admittance_GET$002D$002FData$002FAdmittance$002FclientNr$002FPrincipalPrivileges$002FprincipalId$002F$002DAsync, Admittance_POST$002D$002Fadmittance$002FprincipalId$002Fuser$002F$002DAsync, Models_impersonateDTO, Admittance_POST$002D$002Fadmittance$002Fimpersonate$002F$002DAsync, Admittance_GET$002D$002Fadmittance$002FclientNr$002F$002DAsync, Admittance_GET$002D$002FData$002FAdmittance$002FclientNr$002F$002DAsync } from "../../ApiClient/WebApi.js";
import { dep } from "../../ApiClient/Client.js";
import { fromInteger } from "../../fable_modules/fable-library.3.7.20/Long.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";

export function loadAdmittanceUsers(clientNr) {
    return mapError(Admittance_GET$002D$002FData$002FAdmittance$002FclientNr$002F$002DAsync(dep, fromInteger(clientNr, false, 2)));
}

export function loadAdmittanceUsersFromFenix(clientNr) {
    return mapError(Admittance_GET$002D$002Fadmittance$002FclientNr$002F$002DAsync(dep, fromInteger(clientNr, false, 2)));
}

export function loadImpersonateUser(principalId) {
    let a;
    return handleExceptions((a = Admittance_POST$002D$002Fadmittance$002Fimpersonate$002F$002DAsync(dep, new Models_impersonateDTO(principalId)), singleton.Delay(() => singleton.Bind(a, (_arg_1) => {
        let _arg;
        return singleton.Return((_arg = _arg_1, (_arg.tag === 0) ? (new FSharpResult$2(0, void 0)) : ((_arg.fields[0].tag === 2) ? (new FSharpResult$2(0, void 0)) : ((_arg.fields[0].tag === 1) ? (new FSharpResult$2(1, _arg.fields[0].fields[0])) : (new FSharpResult$2(1, _arg.fields[0].fields[0]))))));
    }))));
}

export function saveMfa(principalId, body) {
    return mapError(Admittance_POST$002D$002Fadmittance$002FprincipalId$002Fuser$002F$002DAsync(dep, principalId, body));
}

export function loadPrincipalPrivileges(clientNr, principalId) {
    return mapError(Admittance_GET$002D$002FData$002FAdmittance$002FclientNr$002FPrincipalPrivileges$002FprincipalId$002F$002DAsync(dep, fromInteger(clientNr, false, 2), toText(printf("%i"))(principalId)));
}

export function saveIpWhiteList(principalId, ipWhiteList) {
    return mapError(Admittance_PUT$002D$002Fadmittance$002FprincipalId$002Fipwhitelist$002F$002DAsync(dep, principalId, new Models_updateIpWhiteListDTO(ipWhiteList)));
}

export function loadUserPrincipalPrivileges(principalId) {
    return mapError(Admittance_GET$002D$002Fadmittance$002FprincipalId$002Fprincipalprivileges$002F$002DAsync(dep, principalId));
}

